import React, { Component } from "react";
import {
  MDBIcon,
} from "mdb-react-ui-kit";

import "./ProjectDetail.css";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { mfmFramedUrl, mfmMediumUrl, mfmOriginalUrl } from "Projects/CC_cubi_clan_project/Utils/MfmService";
import { MfmPhoto } from "Projects/CC_cubi_clan_project/GlobalComponents/MfmPhoto/MfmPhoto";
import LightboxGallery from "Projects/CC_cubi_clan_project/GlobalComponents/LightboxGallery/LightboxGallery";
import Logger from "Projects/CC_cubi_clan_project/Utils/Logger";
import profile_default from "images/profile_default.png";
import ModalPortal from "../AdminProjectDetail/modals/ModalPortal";
import TeaserVideoPlayer from "../Common/TeaserVideoPlayer";

const toAbsUrl = (url) => /^https?:\/\//i.test(url) ? url : 'https://' + url;
const addTargetBlank = (html) => html ? html.replace(/<a href=/gi, '<a target="_blank" rel="noopener noreferrer" href=') : html;

const PORTRAIT_FORMAT_KEY = "ratio:3:4";
const WIDE_FORMAT_KEY = "ratio:16:9";
const PROJECT_HERO_FORMAT_KEY = "ratio:60:19";

export default class ProjectDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectId: null,
      project: {},
      loading: true,
      error: null,
      audioPlaying: false,
      roleDetail: null,
      videoDetail: null,
      locationDetail: null,
      commentDetail: null,
    };

    this._mounted = false;
    this.audioRef = React.createRef();
    this.videosRowRef = React.createRef();
    this.locationsRowRef = React.createRef();
    this.commentsRowRef = React.createRef();
  }

  componentDidMount() {
    this._mounted = true;
    this.checkSelectedProject();
    this.applyAudioPlayback();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.projectId !== prevState.projectId) {
      this.loadProject(this.state.projectId);
    }

    if (this.state.audioPlaying !== prevState.audioPlaying) {
      this.applyAudioPlayback();
    }
    if (
      this.audioRef.current &&
      this.audioRef.current !== (this._lastAudioEl || null)
    ) {
      this._lastAudioEl = this.audioRef.current;
      this.applyAudioPlayback();
    }
  }

  checkSelectedProject() {
    const location = "" + window.location;
    const match = location.match(/project\/([^/]+)$/);

    if (match) {
      const slug = match[1];
      this.setState({ projectId: slug });
    } else {
      this.setState({ projectId: null });
    }
  }

  componentWillUnmount() {
    this._mounted = false;
    const audioEl = this.audioRef.current;
    if (audioEl) {
      try {
        audioEl.pause();
      } catch {}
    }
  }

  // ---- Fetch de proyecto (mismo patrón que UserEditModal) ----
  loadProject = async (id) => {
    this.setState({ loading: true, error: null });
    const requestOptions = { method: "GET" };
    const method = "getProyecto?slug=" + id;

    doFetch("TEAN", method, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (!this._mounted) return;
        const p = data.DATA;
        if (!p) {
          this.setState({ project: {}, loading: false, error: "Proyecto no encontrado" });
          return;
        }
        Logger.debug("TEAN", "ProjectDetail.loadProject", {
          personajes: (p?.personajes || []).length,
          personajesData: (p?.personajes || []).map(per => ({
            id: per.idPersonaje, name: per.name, description: per.description,
            roles: (per.roles || []).map(r => ({
              idRol: r.idRol,
              actor: r.actor?.name,
              roleImg: r.imageBase64 ? "SI" : "NO",
              personajeImg: per.imageBase64 ? "SI" : "NO",
            }))
          }))
        });
        this.setState({ project: p, loading: false });
      })
      .catch((error) => {
        if (!this._mounted) return;
        Logger.error("TEAN", "ProjectDetail.loadProject", error);
        this.setState({ loading: false, error: "Error al cargar el proyecto" });
      })
      .finally(() => {
        if (this.props.onLoading) this.props.onLoading(false);
      });
  };

  // ---- Lógica equivalente al useEffect del audio ----
  applyAudioPlayback = () => {
    const audioEl = this.audioRef.current;
    if (!audioEl) return;
    if (this.state.audioPlaying) {
      audioEl.play().catch(() => {});
    } else {
      audioEl.pause();
    }
  };

  _setAudioPlaying = (valueOrUpdater) => {
    this.setState((prev) => ({
      audioPlaying:
        typeof valueOrUpdater === "function"
          ? !!valueOrUpdater(prev.audioPlaying)
          : !!valueOrUpdater,
    }));
  };

  onBack = () => {
    this.props.onHandleNavLinks && this.props.onHandleNavLinks({ force: "Projects" }, "/projects");
  };

  openRoleDetail = (personaje, rol) => {
    this.setState({ roleDetail: { personaje, rol } });
  };

  closeRoleDetail = () => {
    this.setState({ roleDetail: null });
  };

  /** Devuelve la URL de imagen con prioridad: rol → personaje → actor publicado → imagen por defecto. */
  resolveImage = (rol, personaje) => {
    if (rol?.imageUuid)           return mfmFramedUrl(rol.imageUuid,       270, 360, PORTRAIT_FORMAT_KEY);
    if (personaje?.imageUuid)     return mfmFramedUrl(personaje.imageUuid, 270, 360, PORTRAIT_FORMAT_KEY);
    if (rol?.actor?.status === "published" && rol?.actor?.imageUuid)
                                  return mfmFramedUrl(rol.actor.imageUuid,  270, 360, PORTRAIT_FORMAT_KEY);
    return profile_default;
  };

  /** Devuelve el UUID de imagen con prioridad: rol → personaje → actor publicado → null. */
  resolveUuid = (rol, personaje) => {
    if (rol?.imageUuid)        return rol.imageUuid;
    if (personaje?.imageUuid)  return personaje.imageUuid;
    if (rol?.actor?.status === "published" && rol?.actor?.imageUuid) return rol.actor.imageUuid;
    return null;
  };

  resolveVideoSrc = (video) => {
    if (video?.fileUrl) return video.fileUrl;
    if (video?.videoUuid) return mfmOriginalUrl(video.videoUuid);
    return "";
  };

  render() {
    const { project, loading, error, audioPlaying, roleDetail, videoDetail, locationDetail, commentDetail } = this.state;

    if (loading) return <div className="project-detail"><p>Cargando proyecto...</p></div>;
    if (error) return (
      <div className="project-detail">
        <button className="back-link" onClick={() => this.onBack()}>← Volver</button>
        <p className="text-muted mt-3">{error}</p>
      </div>
    );
    if (!project || !project.title) return (
      <div className="project-detail">
        <button className="back-link" onClick={() => this.onBack()}>← Volver</button>
        <p className="text-muted mt-3">No se ha encontrado el proyecto.</p>
      </div>
    );

    // ---- Ordenar colecciones ----
    const bySortOrder = (a, b) => (a?.sortOrder ?? 0) - (b?.sortOrder ?? 0);

    // Representaciones y comentarios: solo futuras, ordenadas por la sesión más próxima.
    const now = new Date();
    const getFutureFechas = (rep) =>
      (rep.fechas || [])
        .filter((f) => f.startDatetime && new Date(f.startDatetime) > now)
        .sort((a, b) => new Date(a.startDatetime) - new Date(b.startDatetime));

    const representacionesSorted = (project.representaciones || [])
      .filter((r) => String(r.status || "").trim().toLowerCase() === "published")
      .slice()
      .sort((a, b) => {
        const fa = getFutureFechas(a)[0]?.startDatetime;
        const fb = getFutureFechas(b)[0]?.startDatetime;
        if (fa && fb) return new Date(fa) - new Date(fb);
        if (fa) return -1;
        if (fb) return 1;
        return 0;
      });

    // La siguiente representación: la primera en el array (la más próxima) — solo si tiene sesiones futuras
    const nextRepId = (() => {
      if (representacionesSorted.length === 0) return null;
      const first = representacionesSorted[0];
      return getFutureFechas(first).length > 0 ? first.idRepresentacion : null;
    })();

    // Fecha de la próxima sesión para el ribbon del héroe
    const nextRepDate = (() => {
      if (representacionesSorted.length === 0) return null;
      const f = getFutureFechas(representacionesSorted[0])[0];
      if (!f) return null;
      const d = new Date(f.startDatetime);
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    })();    // Aplanar personajes → roles para vista pública.
    // - Personaje draft: oculto completo.
    // - Personaje published + sin roles: una tarjeta sin foto de actor.
    // - Personaje published + con roles: una tarjeta por rol (foto: rol → personaje → actor publicado).
    // El estado del rol no se evalúa; la visibilidad depende solo del personaje.
    const isPublished = (value) => String(value || "").trim().toLowerCase() === "published";
    const flatRoles = [];
    (project.personajes || []).forEach((per) => {
      if (!isPublished(per?.status)) return;

      const roles = Array.isArray(per.roles) ? per.roles : [];
      if (roles.length === 0) {
        flatRoles.push({ personaje: per, rol: null });
        return;
      }
      roles.forEach((rol) => {
        flatRoles.push({ personaje: per, rol });
      });
    });
    flatRoles.sort((a, b) => {
      const left = a.rol?.sortOrder ?? a.personaje?.sortOrder ?? 0;
      const right = b.rol?.sortOrder ?? b.personaje?.sortOrder ?? 0;
      if (left !== right) {
        return left - right;
      }
      return (a.personaje?.sortOrder ?? 0) - (b.personaje?.sortOrder ?? 0);
    });

    const fotosSorted = (project.fotos || [])
      .slice()
      .sort(bySortOrder);
    const videosSorted = (project.videos || [])
      .slice()
      .sort(bySortOrder);



    const comentariosSorted = (project.comentarios || [])
      .slice()
      .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
    // -----------------------------------------------------------------------

    const projectImageSrc = project?.imageUuid
      ? mfmFramedUrl(project.imageUuid, 1200, 380, PROJECT_HERO_FORMAT_KEY)
      : project?.imageBase64
        ? String(project.imageBase64).startsWith("data:")
          ? project.imageBase64
          : `data:image/jpeg;base64,${project.imageBase64}`
        : null;

    return (
      <div className="project-detail">
        {/* AUDIO (si hay themeUrl) */}
        {project.themeUrl && (
          <audio ref={this.audioRef} src={project.themeUrl} loop />
        )}
        {project.themeUrl && (
          <ModalPortal>
            <button
              className="audio-toggle-floating"
              onClick={() => this._setAudioPlaying((prev) => !prev)}
              title={audioPlaying ? "Pausar música" : "Reproducir música"}
            >
              <MDBIcon fas icon={audioPlaying ? "volume-mute" : "volume-up"} />
            </button>
          </ModalPortal>
        )}

        <button className="back-link" onClick={() => this.onBack()}>
          ← Volver
        </button>

        {/* NUEVO: Imagen de cabecera del proyecto */}
        {projectImageSrc && (
          <div className="project-hero mb-3">
            {nextRepDate && (
              <div className="project-hero-ribbon">
                <span>{nextRepDate}</span>
              </div>
            )}
            <img
              className="project-hero-img"
              src={projectImageSrc}
              alt={project.title || "Imagen del proyecto"}
              draggable={false}
            />
          </div>
        )}

        {/* Título del proyecto */}
        <h2 className="section-title mb-3">{project.title}</h2>

        {/* Sinopsis completa (HTML) */}
        <div className="mb-4">
          {project.synopsis && (
            <div
              className="project-synopsis"
              dangerouslySetInnerHTML={{ __html: addTargetBlank(project.synopsis) }}
            />
          )}
        </div>

        {/* Representaciones */}
        {representacionesSorted.length > 0 && (() => {
          const anyHasImage = representacionesSorted.some(r => r.imageUuid || r.imageBase64);
          const visibleCount = 4;
          return (
          <div className="mb-4">
            <h3 className="project-subtitle">Representaciones</h3>
            <div className="lightbox-gallery-row-wrapper">
              {representacionesSorted.length > visibleCount && (
                <button
                  className="lightbox-row-nav left"
                  onClick={() => {
                    const c = this.locationsRowRef?.current;
                    if (c) c.scrollBy({ left: -c.clientWidth * 0.8, behavior: 'smooth' });
                  }}
                  aria-label="Anterior"
                >
                  <i className="fas fa-chevron-left" />
                </button>
              )}
              <div className="lightbox-gallery-row" ref={this.locationsRowRef}>
                {representacionesSorted.map((rep, idx) => {
                  const img = rep.imageUuid
                    ? mfmFramedUrl(rep.imageUuid, 320, 180, WIDE_FORMAT_KEY)
                    : rep.imageBase64
                    ? (String(rep.imageBase64).startsWith('data:') ? rep.imageBase64 : `data:image/jpeg;base64,${rep.imageBase64}`)
                    : null;
                  const isNext = rep.idRepresentacion != null && rep.idRepresentacion === nextRepId;
                  return (
                    <div
                      key={idx}
                      className="lightbox-gallery-row-item"
                      style={{ flex: `0 0 calc(${100 / visibleCount}% - 10px)`, maxWidth: `calc(${100 / visibleCount}% - 10px)` }}
                    >
                      <div className="location-card">
                        {isNext && (
                          <div className="location-next-badge">
                            <i className="fas fa-star me-1" />Próximamente
                          </div>
                        )}
                        {anyHasImage && (
                          <div className="location-thumb">
                            {img ? <img src={img} alt={rep.name || 'Lugar'} /> : <div className="location-thumb--empty"><i className="fas fa-map-marker-alt" /></div>}
                          </div>
                        )}
                        <div className="location-body">
                          <h4 className="location-name">{rep.name || '\u00A0'}</h4>
                          {rep.address && (
                            <div className="location-address"><i className="fas fa-map-pin me-1" />{rep.address}</div>
                          )}
                          {(() => { const next = getFutureFechas(rep)[0]; return next ? (
                            <div className="location-fecha-item">
                              <span className="location-fecha-badge">
                                <i className="fas fa-calendar-alt me-1" />
                                {new Date(next.startDatetime).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' })}
                              </span>
                              {next.availableTickets !== null && next.availableTickets !== undefined && (
                                <span className={`location-ticket-badge ${next.availableTickets > 0 ? 'available' : 'soldout'}`}>
                                  {next.availableTickets > 0 ? 'Entradas disponibles' : 'Agotado'}
                                </span>
                              )}
                            </div>
                          ) : null; })()}
                          {rep.enlaceUrl && (
                            <a className="location-enlace" href={toAbsUrl(rep.enlaceUrl)} target="_blank" rel="noopener noreferrer">
                              <i className="fas fa-external-link-alt me-1" />Ir al sitio
                            </a>
                          )}
                          <button
                            className="card-ver-mas"
                            onClick={(e) => { e.stopPropagation(); this.setState({ locationDetail: rep }); }}
                          >
                            Ver más
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              {representacionesSorted.length > visibleCount && (
                <button
                  className="lightbox-row-nav right"
                  onClick={() => {
                    const c = this.locationsRowRef?.current;
                    if (c) c.scrollBy({ left: c.clientWidth * 0.8, behavior: 'smooth' });
                  }}
                  aria-label="Siguiente"
                >
                  <i className="fas fa-chevron-right" />
                </button>
              )}
            </div>
          </div>
          );
        })()}

        {/* Reparto público (personaje + roles publicados según reglas de visibilidad) */}
        {flatRoles.length > 0 && (
          <div className="mb-4">
            <h3 className="project-subtitle">Reparto</h3>
            <div className="cast-grid">
              {flatRoles.map(({ personaje, rol }, idx) => {
                const title = personaje?.name || "";
                return (
                  <div
                    key={rol ? `role-${rol.idRol || idx}` : `per-${personaje.idPersonaje || idx}`}
                    className="cast-card cast-card-public"
                    onClick={() => this.openRoleDetail(personaje, rol)}
                  >
                    <div className="cast-card-img-wrapper">
                      <MfmPhoto
                        uuid={this.resolveUuid(rol, personaje)}
                        width={270}
                        height={360}
                        formatKey={PORTRAIT_FORMAT_KEY}
                        className="cast-card-img"
                        fallback={profile_default}
                        alt={title || "personaje"}
                      />
                    </div>
                    <div className="cast-card-body">
                      {title && (
                        <div className="cast-card-title">{title}</div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Modal detalle de personaje/rol */}
        {roleDetail && (() => {
          const { personaje, rol } = roleDetail;
          const detailUuid = this.resolveUuid(rol, personaje);
          const hasImg = !!detailUuid;
          return (
            <ModalPortal>
              <div className="modal-overlay" onClick={this.closeRoleDetail}>
                <div className="modal-card role-detail-card" onClick={(e) => e.stopPropagation()}>
                  {/* Cabecera: título del personaje */}
                  <div className="d-flex justify-content-between align-items-center role-detail-header">
                    <h5 className="role-detail-title mb-0">{personaje?.name || "Personaje"}</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={this.closeRoleDetail}
                      aria-label="Cerrar"
                    />
                  </div>
                  {/* Cuerpo: descripción + notas / foto */}
                  <div className="role-detail-body">
                    <div className="role-detail-left">
                      {/* Descripción del personaje */}
                      {personaje?.description && (
                        <div
                          className="role-detail-desc"
                            dangerouslySetInnerHTML={{ __html: addTargetBlank(personaje.description) }}
                        />
                      )}
                      {/* Notas del rol */}
                      {rol?.notes && (
                        <p className="role-detail-notes mb-0">{rol.notes}</p>
                      )}
                    </div>
                    {hasImg && (
                      <div className="role-detail-right">
                        <MfmPhoto
                          uuid={detailUuid}
                          width={270}
                          height={360}
                          formatKey={PORTRAIT_FORMAT_KEY}
                          className="role-detail-main-img"
                          fallback={profile_default}
                          alt={personaje?.name || "personaje"}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </ModalPortal>
          );
        })()}

        {/* Galería de fotos */}
        {fotosSorted.length > 0 && (
          <div className="mb-4">
            <h3 className="project-subtitle">Galería de fotos</h3>
            <LightboxGallery
              items={fotosSorted.map((f) => f.imageUuid ? mfmMediumUrl(f.imageUuid) : f.imageBase64)}
              showThumbnails={true}
              showIndicators={false}
              downloadable={true}
              singleRow={true}
              visibleCount={6}
              showViewAll={true}
            />
          </div>
        )}

        {/* Vídeos */}
        {videosSorted.length > 0 && (
          <div className="mb-4">
            <h3 className="project-subtitle">Vídeos</h3>
            <div className="lightbox-gallery-row-wrapper">
              {videosSorted.length > 3 && (
                <button
                  className="lightbox-row-nav left"
                  onClick={() => {
                    const c = this.videosRowRef?.current;
                    if (c) c.scrollBy({ left: -c.clientWidth * 0.8, behavior: 'smooth' });
                  }}
                  aria-label="Anterior"
                >
                  <i className="fas fa-chevron-left" />
                </button>
              )}
              <div className="lightbox-gallery-row" ref={this.videosRowRef}>
                {videosSorted.map((video, idx) => (
                  <div
                    key={idx}
                    className="lightbox-gallery-row-item"
                    style={{ flex: `0 0 calc(${100 / 3}% - 10px)`, maxWidth: `calc(${100 / 3}% - 10px)` }}
                  >
                    <div className="video-card">
                      <div className="embedded-video">
                        <TeaserVideoPlayer
                          src={this.resolveVideoSrc(video)}
                          teaserConfigJson={video?.teaserConfigJson || null}
                          controls
                          width="100%"
                          height="100%"
                          style={{ position: "absolute", top: 0, left: 0 }}
                        />
                      </div>
                      <div className="video-card-info">
                        <h4 className="video-title">{video.title || "\u00A0"}</h4>
                        {video.description && (
                          <p className="video-description">{video.description}</p>
                        )}
                      </div>
                      <button
                        className="card-ver-mas"
                        onClick={(e) => { e.stopPropagation(); this.setState({ videoDetail: video }); }}
                      >
                        Ver más
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              {videosSorted.length > 3 && (
                <button
                  className="lightbox-row-nav right"
                  onClick={() => {
                    const c = this.videosRowRef?.current;
                    if (c) c.scrollBy({ left: c.clientWidth * 0.8, behavior: 'smooth' });
                  }}
                  aria-label="Siguiente"
                >
                  <i className="fas fa-chevron-right" />
                </button>
              )}
            </div>
          </div>
        )}


        {/* Comentarios y recortes */}

        {/* Modal detalle de vídeo */}}
        {videoDetail && (
          <ModalPortal>
            <div className="modal-overlay" onClick={() => this.setState({ videoDetail: null })}>
              <div className="modal-card detail-modal-card" onClick={(e) => e.stopPropagation()}>
                <div className="d-flex justify-content-between align-items-center detail-modal-header">
                  <h5 className="detail-modal-title mb-0">{videoDetail.title || 'Vídeo'}</h5>
                  <button type="button" className="btn-close" onClick={() => this.setState({ videoDetail: null })} aria-label="Cerrar" />
                </div>
                <div className="detail-modal-body">
                  <div className="detail-modal-video">
                    <TeaserVideoPlayer
                      src={this.resolveVideoSrc(videoDetail)}
                      teaserConfigJson={videoDetail?.teaserConfigJson || null}
                      controls
                      width="100%"
                      height="100%"
                      style={{ position: 'absolute', top: 0, left: 0 }}
                    />
                  </div>
                  {videoDetail.description && (
                    <div className="detail-modal-section">
                      <p className="detail-modal-text">{videoDetail.description}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </ModalPortal>
        )}

        {/* Modal detalle de lugar */}
        {locationDetail && (() => {
          const locImg = locationDetail.imageUuid
            ? mfmFramedUrl(locationDetail.imageUuid, 960, 540, WIDE_FORMAT_KEY)
            : locationDetail.imageBase64
            ? (String(locationDetail.imageBase64).startsWith('data:') ? locationDetail.imageBase64 : `data:image/jpeg;base64,${locationDetail.imageBase64}`)
            : null;
          const mapUrl = locationDetail.address
            ? `https://www.google.com/maps?q=${encodeURIComponent(locationDetail.address)}&z=15&output=embed`
            : null;
          const mapLink = locationDetail.address
            ? `https://maps.google.com/?q=${encodeURIComponent(locationDetail.address)}`
            : null;
          return (
            <ModalPortal>
              <div className="modal-overlay" onClick={() => this.setState({ locationDetail: null })}>
                <div className="modal-card detail-modal-card" onClick={(e) => e.stopPropagation()}>
                  <div className="d-flex justify-content-between align-items-center detail-modal-header">
                    <h5 className="detail-modal-title mb-0">{locationDetail.name || 'Lugar'}</h5>
                    <button type="button" className="btn-close" onClick={() => this.setState({ locationDetail: null })} aria-label="Cerrar" />
                  </div>
                  <div className="detail-modal-body">
                    <div className={`location-modal-content${locImg ? ' location-modal-content--img' : ''}`}>
                      {locImg ? (
                        <div className="location-modal-img-col">
                          <img src={locImg} alt={locationDetail.name || 'Lugar'} className="location-modal-img" />
                        </div>
                      ) : (
                        <div className="location-modal-no-img-banner">
                          <i className="fas fa-map-marker-alt" />
                        </div>
                      )}
                      <div className="location-modal-info-col">
                        {locationDetail.address && (
                          <div className="detail-modal-meta">
                            <i className="fas fa-map-pin me-2" />
                            {mapLink
                              ? <a href={mapLink} target="_blank" rel="noopener noreferrer" className="detail-modal-link">{locationDetail.address}</a>
                              : <span>{locationDetail.address}</span>
                            }
                          </div>
                        )}
                        {getFutureFechas(locationDetail).length > 0 && (
                          <div className="detail-modal-fechas">
                            {getFutureFechas(locationDetail).map((f, fi) => (
                              <div key={fi} className="location-fecha-item">
                                <span className="location-fecha-badge">
                                  {new Date(f.startDatetime).toLocaleDateString('es-ES', { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' })}
                                  {f.endDatetime && ` – ${new Date(f.endDatetime).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}`}
                                </span>
                                {f.availableTickets !== null && f.availableTickets !== undefined && (
                                  <span className={`location-ticket-badge ${f.availableTickets > 0 ? 'available' : 'soldout'}`}>
                                    {f.availableTickets > 0 ? 'Entradas disponibles' : 'Agotado'}
                                  </span>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                        {locationDetail.description && (
                          <div className="detail-modal-text" dangerouslySetInnerHTML={{ __html: addTargetBlank(locationDetail.description) }} />
                        )}
                        {locationDetail.enlaceUrl && (
                          <a className="location-modal-enlace" href={toAbsUrl(locationDetail.enlaceUrl)} target="_blank" rel="noopener noreferrer">
                            <i className="fas fa-external-link-alt me-1" />Ir al sitio
                          </a>
                        )}
                      </div>
                    </div>
                    {mapUrl && (
                      <div className="location-modal-map-section">
                        <div className="detail-modal-map">
                          <iframe
                            title="Mapa"
                            src={mapUrl}
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </ModalPortal>
          );
        })()}

        {comentariosSorted.length > 0 && (
          <div className="mb-4">
            <h3 className="project-subtitle">Comentarios y recortes</h3>
            <div className="lightbox-gallery-row-wrapper">
              {comentariosSorted.length > 3 && (
                <button
                  className="lightbox-row-nav left"
                  onClick={() => {
                    const c = this.commentsRowRef?.current;
                    if (c) c.scrollBy({ left: -c.clientWidth * 0.8, behavior: 'smooth' });
                  }}
                  aria-label="Anterior"
                >
                  <i className="fas fa-chevron-left" />
                </button>
              )}
              <div className="lightbox-gallery-row" ref={this.commentsRowRef}>
                {comentariosSorted.map((comment, idx) => {
                  const img = comment.imageUuid
                    ? mfmFramedUrl(comment.imageUuid, 320, 180, WIDE_FORMAT_KEY)
                    : comment.imageBase64
                    ? (String(comment.imageBase64).startsWith('data:') ? comment.imageBase64 : `data:image/jpeg;base64,${comment.imageBase64}`)
                    : null;
                  return (
                    <div
                      key={idx}
                      className="lightbox-gallery-row-item"
                      style={{ flex: `0 0 calc(${100 / 3}% - 10px)`, maxWidth: `calc(${100 / 3}% - 10px)` }}
                    >
                      <div className="comment-card">
                        {/* Imagen (si existe) */}
                        {img && (
                          <div className="comment-thumb">
                            <img src={img} alt={comment.authorName || 'Comentario'} />
                          </div>
                        )}
                        <div className="comment-body">
                          {comment.text && (
                            <p className="comment-text">"{comment.text}"</p>
                          )}
                          {comment.authorName && (
                            <div className="comment-author">{comment.authorName}</div>
                          )}
                          {comment.origin && (
                            <div className="comment-origin">{comment.origin}</div>
                          )}
                          {comment.date && (
                            <div className="comment-date"><i className="fas fa-calendar-alt me-1" />{comment.date}</div>
                          )}
                          <button
                            className="card-ver-mas"
                            onClick={(e) => { e.stopPropagation(); this.setState({ commentDetail: comment }); }}
                          >
                            Ver más
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              {comentariosSorted.length > 3 && (
                <button
                  className="lightbox-row-nav right"
                  onClick={() => {
                    const c = this.commentsRowRef?.current;
                    if (c) c.scrollBy({ left: c.clientWidth * 0.8, behavior: 'smooth' });
                  }}
                  aria-label="Siguiente"
                >
                  <i className="fas fa-chevron-right" />
                </button>
              )}
            </div>
          </div>
        )}

        {/* Modal detalle de comentario */}
        {commentDetail && (() => {
          const cmtImg = commentDetail.imageUuid
            ? mfmFramedUrl(commentDetail.imageUuid, 960, 540, WIDE_FORMAT_KEY)
            : commentDetail.imageBase64
            ? (String(commentDetail.imageBase64).startsWith('data:') ? commentDetail.imageBase64 : `data:image/jpeg;base64,${commentDetail.imageBase64}`)
            : null;
          return (
            <ModalPortal>
              <div className="modal-overlay" onClick={() => this.setState({ commentDetail: null })}>
                <div className="modal-card detail-modal-card" onClick={(e) => e.stopPropagation()}>
                  <div className="d-flex justify-content-between align-items-center detail-modal-header">
                    <h5 className="detail-modal-title mb-0">{commentDetail.authorName || 'Comentario'}</h5>
                    <button type="button" className="btn-close" onClick={() => this.setState({ commentDetail: null })} aria-label="Cerrar" />
                  </div>
                  <div className="detail-modal-body">
                    {cmtImg && (
                      <div className="detail-modal-hero">
                        <img src={cmtImg} alt={commentDetail.authorName || 'Comentario'} />
                      </div>
                    )}
                    <div className="detail-modal-section">
                      {commentDetail.text && (
                        <p className="detail-modal-text" style={{ fontStyle: 'italic' }}>"{commentDetail.text}"</p>
                      )}
                      {commentDetail.origin && (
                        <div className="detail-modal-meta">
                          <i className="fas fa-newspaper me-2" />{commentDetail.origin}
                        </div>
                      )}
                      {commentDetail.date && (
                        <div className="detail-modal-meta">
                          <i className="fas fa-calendar-alt me-2" />{commentDetail.date}
                        </div>
                      )}
                      {commentDetail.link && (
                        <div className="detail-modal-meta">
                          <i className="fas fa-link me-2" />
                          <a href={commentDetail.link} target="_blank" rel="noopener noreferrer" className="detail-modal-link">
                            {commentDetail.link}
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </ModalPortal>
          );
        })()}
      </div>
    );
  }
}
